import React from 'react';
import addCountToString from '../../../utils/addCountToString';
import { PillOption, MultiSelectPillSelect } from '../../v2BaseComponents/Inputs/PillSelect';
import Stack, { contentStackSpacing } from '../../v2BaseComponents/Stack';
import Text from '../../v2BaseComponents/Text';

export type Option<TValue> = {
    label: string;
    value: TValue;
    count?: number;
};

export type MultiSelectFilterOwnProps<TValue extends string> = {
    value: TValue[] | null;
    onChange: (value: TValue[] | null) => void;
    options: Option<TValue>[];
    onClear?: () => void;
    title: string;
};

export type MultiSelectFilterProps<TValue extends string> = MultiSelectFilterOwnProps<TValue>;

function MultiSelectFilter<TValue extends string>(props: MultiSelectFilterProps<TValue>) {
    const pillOptions: PillOption[] = props.options.map((option) => ({
        label: option.count === undefined ? option.label : addCountToString(option.label, option.count),
        value: option.value,
    }));
    return (
        <Stack vertical space={contentStackSpacing} fullWidth align="flex-start">
            <Text variant="h6">{props.title}</Text>
            <MultiSelectPillSelect
                options={pillOptions}
                value={props.value}
                onChange={(value) => props.onChange(value as TValue[])}
                pillContainerStyle={{ flexWrap: 'wrap', rowGap: 5 }}
            />
        </Stack>
    );
}

export default MultiSelectFilter;
